import { SleepFactory } from './sleepFactory';

import type {
  SleepEntity,
  SleepPropsPub,
  SleepPropsPvt,
} from './sleepEntity';
import type { SleepIRepository } from './sleepIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { SleepJsonPub, SleepJsonPvt } from '@/types/domain/sleep/entities/sleepEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class SleepRepository extends AppsyncRepository<
  SleepEntity,
  SleepPropsPvt,
  SleepJsonPvt,
  SleepPropsPub,
  SleepJsonPub
> implements SleepIRepository {
  private factory = new SleepFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppSleepSleepWakeupEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
